import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowRightDownLine = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M16.9999 15.5855V9.99992C16.9999 9.44763 17.4476 8.99991 17.9999 8.99991C18.5522 8.99991 18.9999 9.44763 18.9999 9.99992V17.9999C18.9999 18.5522 18.5522 18.9999 17.9999 18.9999H9.99992C9.44763 18.9999 8.99992 18.5522 8.99992 17.9999C8.99992 17.4476 9.44763 16.9999 9.99992 16.9999H15.5859L5.63591 7.04988C5.24539 6.65936 5.24539 6.02619 5.63591 5.63567C6.02643 5.24514 6.6596 5.24514 7.05012 5.63567L16.9999 15.5855Z" })
});
export default SvgArrowRightDownLine;
